module.exports = __webpack_public_path__ + "static/media/epark-off-app-provider-icon.da1c26bb.svg";